import { useEffect } from 'react';
/**
 * Listen for a specific event on an EventEmitter
 * @param eventEmitter EventEmitter to listen to
 * @param eventName Name of the event to listen to
 * @param callback Callback to call when the event is triggered
 */
export function useListener(eventEmitter, eventName,
// eslint-disable-next-line @typescript-eslint/ban-types
callback) {
  useEffect(function initEventEmitter() {
    eventEmitter.on(eventName, callback);
    return () => {
      eventEmitter.off(eventName, callback);
    };
  }, [eventEmitter, eventName, callback]);
}
export default useListener;
//# sourceMappingURL=useListener.js.map